/* 🤖 this file was generated by svg-to-ts */
export const matIconPageview: {
  name: 'pageview';
  data: string;
} = {
  name: 'pageview',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11.49 16c.88 0 1.7-.26 2.39-.7l2.44 2.44 1.42-1.42-2.44-2.43c.44-.7.7-1.51.7-2.39C16 9.01 13.99 7 11.5 7S7 9.01 7 11.5 9.01 16 11.49 16zm.01-7a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/></svg>`
};
